"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactRouterPathMatching = void 0;
/**
 * Performs pattern matching on a URL pathname and returns information about the
 * match.
 */
function matchPath(pattern, pathname) {
    if (typeof pattern === "string") {
        pattern = { path: pattern };
    }
    const { path, caseSensitive = false, end = true } = pattern;
    const [matcher, paramNames] = compilePath(path, caseSensitive, end);
    const match = pathname.match(matcher);
    if (!match)
        return null;
    const matchedPathname = match[1];
    const values = match.slice(2);
    const params = paramNames.reduce((memo, paramName, index) => {
        memo[paramName] = safelyDecodeURIComponent(values[index], paramName);
        return memo;
    }, {});
    return { path, pathname: matchedPathname, params };
}
function compilePath(path, caseSensitive, end) {
    const keys = [];
    let source = "^(" +
        path
            .replace(/^\/*/, "/") // Make sure it has a leading /
            .replace(/\/?\*?$/, "") // Ignore trailing / and /*, we'll handle it below
            .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
            .replace(/:(\w+)/g, (_, key) => {
            keys.push(key);
            return "([^\\/]+)";
        }) +
        ")";
    if (path.endsWith("*")) {
        if (path.endsWith("/*")) {
            source += "\\/?"; // Don't include the / in params['*']
        }
        keys.push("*");
        source += "(.*)";
    }
    else if (end) {
        source += "\\/?";
    }
    if (end)
        source += "$";
    const flags = caseSensitive ? undefined : "i";
    const matcher = new RegExp(source, flags);
    return [matcher, keys];
}
function safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value.replace(/\+/g, " "));
    }
    catch (error) {
        warning(false, `The value for the URL param "${paramName}" will not be decoded because` +
            ` the string "${value}" is a malformed URL segment. This is probably` +
            ` due to a bad percent encoding (${error}).`);
        return value;
    }
}
function warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined")
            console.warn(message);
        try {
            throw new Error(message);
            // eslint-disable-next-line no-empty
        }
        catch (e) { }
    }
}
exports.ReactRouterPathMatching = {
    matchPath,
};
